/* ------------------------------------------------------------------
   File: Partnerships.jsx
   Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
   Last Modified: 2026-06-19
------------------------------------------------------------------ */

import React from 'react'

function Partnerships() {
  return (
    <div>
      Welcome to Partnership page
    </div>
  )
}

export default Partnerships
